import { Outlet } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { MyRequestsDataCollectionDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmptyState } from './EmptyState'
import { MyRequestsDataCollection } from './MyRequestsDataCollection'

export function RequestsComponent() {
  const {
    company: { id: companyId }
  } = useCurrentSession()

  const { data, loading } = useQuery(MyRequestsDataCollectionDocument, {
    variables: {
      companyId,
      employeesOrAuthor: true
    }
  })

  const canCreate = Boolean(data?.trainings?._policies.trainingsRequestsCreate.can)
  const isEmpty = data?.trainings?.trainingRequestsConnection.nodes.length === 0
  const emptyCatalog = data?.trainings?.trainingsConnection.nodes.length === 0

  if (loading) {
    return null
  }

  if (isEmpty) {
    return (
      <ResponsivePage.Body variant="full" showHeader={false}>
        <EmptyState canCreate={canCreate} emptyCatalog={emptyCatalog} />
        <Outlet />
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body variant="full">
      <MyRequestsDataCollection canCreate={canCreate} />
      <Outlet />
    </ResponsivePage.Body>
  )
}
